import { matchesSearchText, normalizeSearchText } from "../../shared/search";

export const normalizeCollectionSearch = normalizeSearchText;

export function matchesCollectionSearch(query: string, values: Array<string | number | null | undefined>) {
  return matchesSearchText(query, values);
}
